import { gql, MutationHookOptions, TypedDocumentNode, useMutation } from "@apollo/client";

import {
  ActivateScenarioVersionMutation,
  ActivateScenarioVersionMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { scenarioVersionWithRulesFragment } from "src/graphql/anti-fraud/fragments/ScenarioVersionFragment";

export const activateScenarioVersionMutation = gql`
  mutation activateScenarioVersion($id: ID!) {
    activateVersion(id: $id) {
      ...ScenarioVersionWithRulesFragment
    }
  }

  ${scenarioVersionWithRulesFragment}
` as TypedDocumentNode<ActivateScenarioVersionMutation, ActivateScenarioVersionMutationVariables>;

export const useActivateScenarioVersionMutation = (
  options?: MutationHookOptions<
    ActivateScenarioVersionMutation,
    ActivateScenarioVersionMutationVariables
  >
) => {
  return useMutation(activateScenarioVersionMutation, options);
};
